export const HEADER_HEIGHT = 80;
export const FOOTER_HEIGHT = 476;

export const CARDS_CAROUSEL_SPACING = 100;
export const LANDING_MAIN_CAROUSEL_CARDS_WIDTH = 945;
export const LANDING_MAIN_CAROUSEL_CARDS_NUMBER = 4;

export const CARDS_CAROUSEL_WIDTH =
  LANDING_MAIN_CAROUSEL_CARDS_WIDTH * LANDING_MAIN_CAROUSEL_CARDS_NUMBER +
  CARDS_CAROUSEL_SPACING * (LANDING_MAIN_CAROUSEL_CARDS_NUMBER + 2);

export const MOBILE_BREAKPOINT = 768;

export const GLOBAL_SEARCH_HOME_TOP = 254;

export const COLOR_NEW_YELLOW_1 = '#E8FF77';

// Redesign 2026
export const HEADER_HEIGHT_L = 115;
export const HEADER_HEIGHT_S = 92;
export const BREAK_POINT_SMALL_TO_LARGE = 1200;
export const BREAK_POINT_LARGE_TO_EXTRA_LARGE = 1440;
